import { ObjectRef } from './object.js';
export class SubscriptionRef extends ObjectRef {
}
//# sourceMappingURL=subscription.js.map
